import React, { Fragment } from 'react'
import {
  Control,
  FieldErrors,
  Path,
  RegisterOptions,
  UseFormRegister,
  useWatch,
} from 'react-hook-form'
import { AppraisalFormProps } from '../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'

interface ApTextareaProps {
  name: Path<AppraisalFormProps>
  index: number
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  rules?: RegisterOptions<AppraisalFormProps>
  control: Control<AppraisalFormProps>
}

const ApCheckboxOpen: React.FC<ApTextareaProps> = ({
  name,
  index,
  register,
  errors,
  rules,
  control,
}) => {
  const value = useWatch({
    control,
    name,
  })
  // console.log('value', value, 'c', control, 'name', name, 'typeof', typeof value)
  return (
    <Fragment>
      <div className='col-md-1'>
        <input
          type='radio'
          {...register(name, rules)}
          id={`custom-checkbox${index}0`}
          value={0}
          checked={String(value) === '0'}
        />
        <label
          htmlFor={`custom-checkbox${index}0`}
          className={`red ${value === 0 ? 'active' : ''}`}
        >
          Red
        </label>
      </div>
      <div className='col-md-1'>
        <input
          type='radio'
          {...register(name, rules)}
          id={`custom-checkbox${index}1`}
          value={1}
          checked={String(value) === '1'}
        />
        <label
          htmlFor={`custom-checkbox${index}1`}
          className={`yellow ${value === 1 ? 'active' : ''}`}
        >
          Yellow
        </label>
      </div>
      <div className='col-md-1'>
        <input
          type='radio'
          {...register(name, rules)}
          id={`custom-checkbox${index}2`}
          value={2}
          checked={String(value) === '2'}
        />
        <label
          htmlFor={`custom-checkbox${index}2`}
          className={`green ${value === 2 ? 'active' : ''}`}
        >
          Green
        </label>
      </div>

      {errors && errors.coreValues && (
        <div className='invalid-feedback'>{errors.coreValues[index]?.employee_score?.message}</div>
      )}
    </Fragment>
  )
}

export default ApCheckboxOpen
